import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { CONTENT_BLOCKS, CONTENT_IMAGE, CONTENT_TEXTURES } from './salesData';

/**
 * QUÉ VAS A APRENDER. No es una lista de archivos: es el recorrido de la
 * receta a una cookie que da ganas de probar.
 */
export function ContentSection() {
  return <section id="aprendes" className="scroll-mt-24 overflow-hidden bg-cream py-14 sm:py-20" aria-labelledby="content-title" data-id="element-85" data-mp="lr0j3h51nd61">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-86" data-mp="c1z3vt6bozt4">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-87" data-mp="c0e7dy0g76sm">
          <div className="lg:col-span-5" data-id="element-88" data-mp="73nu1ig12paw">
            <SectionTag data-id="element-89" data-mp="70jghugoah7k">Qué vas a aprender</SectionTag>
            <h2 id="content-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-90" data-mp="322a5d52tar7">
              Mucho más que una lista de recetas
            </h2>
            <p className="mt-4 max-w-md font-sans text-[0.95rem] leading-relaxed text-charcoal-mid" data-id="element-91" data-mp="3pabzxaiwjghm">
              Todo organizado para ayudarte a pasar de la receta a una cookie que realmente dé ganas
              de probar.
            </p>

            <motion.figure initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.32,
            ease: [0.23, 1, 0.32, 1]
          }} className="relative mt-8 overflow-hidden rounded-5xl shadow-bakery" data-id="element-92" data-mp="38kflra4wa4r5">
              <img src={CONTENT_IMAGE} alt="Bandeja llena de cookies gruesas recién horneadas con chocolate fundido encima." loading="lazy" decoding="async" className="aspect-[4/3] w-full object-cover" data-id="element-93" data-mp="93zhfvq2nvyi" />
            </motion.figure>

            <ul className="mt-4 grid grid-cols-3 gap-3 sm:gap-4" data-id="element-94" data-mp="2fxl3mjvjvhgu">
              {CONTENT_TEXTURES.map((texture, index) => <motion.li key={texture.id} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.26,
              ease: [0.23, 1, 0.32, 1],
              delay: index * 0.04
            }} data-id="element-95" data-mp="20sqe640tmicw" data-mpi={index}>
                  <img src={texture.image} alt={texture.alt} loading="lazy" decoding="async" className="aspect-square w-full rounded-3xl object-cover shadow-bakery-sm" data-id="element-96" data-mp="1i2s81tgl2zbw" />
                </motion.li>)}
            </ul>
          </div>

          <ul className="lg:col-span-7" data-id="element-97" data-mp="33f1zn51y37g0">
            {CONTENT_BLOCKS.map((block, index) => <motion.li key={block.id} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(index, 4) * 0.035
          }} className="flex items-start gap-4 border-b border-warm py-5 first:border-t sm:gap-6" data-id="element-98" data-mp="2yfz6oiz8oroe" data-mpi={index}>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-caramel-pale font-sans text-[0.66rem] font-bold tabular-nums text-[#F47A2A] sm:h-11 sm:w-11 sm:text-[0.76rem]" data-id="element-99" data-mp="2n0vu1pvqjm0g">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div data-id="element-100" data-mp="310f1shkmwvc8">
                  <h3 className="font-display text-[1.08rem] leading-tight text-charcoal sm:text-[1.35rem]" data-id="element-101" data-mp="310wxnd3dx7jm">
                    {block.title}
                  </h3>
                  <p className="mt-2 max-w-xl font-sans text-[0.88rem] leading-relaxed text-charcoal-mid" data-id="element-102" data-mp="caxbnk35kpah">
                    {block.body}
                  </p>
                </div>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}